import { Component, Input } from '@angular/core';
import { ConversionResult, ConversionWarning } from '@nx-ahs/formly/shared';

@Component({
	selector: 'nx-ahs-conversion-warnings',
	templateUrl: './conversion-warnings.component.html',
	styleUrls: ['./conversion-warnings.component.scss'],
	standalone: false
})
export class ConversionWarningsComponent {
	@Input() conversionResult: ConversionResult | null = null;

	/**
	 * Get warnings by severity
	 */
	public get errors(): ConversionWarning[] {
		return this.conversionResult?.warnings.filter((w) => w.severity === 'error') || [];
	}

	public get warnings(): ConversionWarning[] {
		return this.conversionResult?.warnings.filter((w) => w.severity === 'warning') || [];
	}

	public get infos(): ConversionWarning[] {
		return this.conversionResult?.warnings.filter((w) => w.severity === 'info') || [];
	}

	/**
	 * Get overall status icon and color
	 */
	public get statusIcon(): string {
		if (this.errors.length > 0) {
			return 'error';
		}
		if (this.warnings.length > 0) {
			return 'warning';
		}
		return 'check_circle';
	}

	public get statusColor(): string {
		if (this.errors.length > 0) {
			return 'error';
		}
		if (this.warnings.length > 0) {
			return 'warning';
		}
		return 'success';
	}

	public get statusMessage(): string {
		const stats = this.conversionResult?.statistics;
		if (!stats) {
			return 'No conversion data available';
		}

		if (this.errors.length > 0) {
			return `${stats.convertedNodes} field(s) converted, ${this.errors.length} error(s)`;
		}
		if (this.warnings.length > 0) {
			return `${stats.convertedNodes} field(s) converted, ${this.warnings.length} warning(s)`;
		}
		return `${stats.convertedNodes} field(s) converted successfully`;
	}
}
